export const global_function = {
    methods: {
        update_meta: function (meta) {
            if( this.$route.path != '/tag/{idtag}/{tag}')
            {
                if(meta.title == undefined)
                    meta.title = "Berita Harian Terkini dan Terlengkap | Liputan6.com";

                if(meta.description == undefined)
                    meta.description = "Liputan6.com - Berita hari ini Indonesia dan Dunia, kabar terbaru terkini. Situs berita terpercaya dari politik, peristiwa, bisnis, bola, tekno hingga gosip artis";
                
                if(meta.keyword == undefined)
                    meta.keyword = "berita hari ini, berita harian, berita terkini, berita terbaru, berita indonesia, berita terpopuler, berita, info terkini, berita dunia, peristiwa hari ini";
                
                if(meta.url == undefined)
                    meta.url = "https://www.liputan6.com/";
                
                if(meta.image == undefined)
                    meta.image = "https://cdn0-production-images-kly.akamaized.net/QI880kU5DBio5ZoyVCGC4UsbWxs=/600x400/smart/filters:quality(75):strip_icc():format(jpeg)/kly-media-production/medias/2760942/original/039580700_1553559051-1.jpg";
            }

            document.title = meta.title;
            document.head.querySelector('meta[name=title]').content = meta.title;
            document.head.querySelector('meta[name=description]').content = meta.description;
            document.head.querySelector('meta[name=keyword]').content = meta.keyword;
            document.head.querySelector('meta[property="og:title"]').content = meta.title;
            document.head.querySelector('meta[property="og:description"]').content = meta.description;
            document.head.querySelector('meta[property="og:url"]').content = meta.url;
            document.head.querySelector('meta[property="og:image"]').content = meta.image;
            document.head.querySelector('link[rel=canonical]').href = meta.url;
            
            if( this.$route.path == '/')
            {
                let publish_at = new Date();
                let month = publish_at.getMonth()  + 1;
                month = (month < 10 ? "0" : "") + month;
                publish_at = publish_at.getFullYear() + "-" + month + "-" + publish_at.getDate();

                // ga('set', 'dimension1', "");
                // ga('set', 'dimension2', "root");
                // ga('set', 'dimension3', "");
                // ga('set', 'dimension4', "");
            }
            else
            {
                let value = meta.published_at;
                let publish_at=null
                if (value == undefined) {
                    publish_at = new Date();
                }else{
                    value = value.replace(/-/g, '/');
                    publish_at = new Date(value);
                }
                let month = publish_at.getMonth()  + 1;
                month = (month < 10 ? "0" : "") + month;
                publish_at = publish_at.getFullYear() + "-" + month + "-" + publish_at.getDate();

                // ga('set', 'dimension1', publish_at);
                // ga('set', 'dimension2', meta.category_name !== undefined ? meta.category_name.toLowerCase() : "");
                // ga('set', 'dimension3', meta.tag_name !== undefined ? meta.tag_name.toLowerCase() : "");
                // ga('set', 'dimension4', meta.publisher_name !== undefined ? meta.publisher_name : "");
            }

            // ga('send', {
            //     hitType: 'pageview',
            //     page: this.$route.path,
            //     title: meta.title,
            //     location: meta.url
            // });
        },
        get_image: function(photos,backup_photos=null)
        {
            var rs_photo = photos.filter(
                function(photo){
                    return photo.photo_ratio == '2:1';
                }
            )
            let image='';
            let domain= this.domain;
            if (domain) {
                if(rs_photo == undefined || rs_photo == null || rs_photo.length == 0)
                {
                    rs_photo = photos;
                }
                if(domain.includes('otosia')){
                    image = 'assets/pwa/assets/image-default-otosia.png';
                }
                else if(domain.includes('enamplus')){
                    image = 'assets/pwa/assets/image-default-enam-plus.png';
                }
                else{
                    if (this.subDomain) {
                        image = 'assets/pwa/assets/image-default-'+this.subDomain+'.png';
                    } else {
                        image = 'assets/pwa/assets/image-default.png';
                    }
                }
            } else {
                if(rs_photo == undefined || rs_photo == null || rs_photo.length == 0)
                {
                    rs_photo = photos;
                }
                else{
                    image = 'assets/pwa/assets/image-default.png';
                }
            }
            if(rs_photo.length > 0)
            {
                image = rs_photo[0].photo_url;
            }else if(domain.includes('enamplus') && backup_photos && backup_photos.length > 0)
            {
                image = backup_photos[0].video_cover;
            }

            if(image.indexOf('merdeka.com') > 0)
            {
                image = image.replace('300x300', '670x335');
            }

            return image.replace('https://klimg', 'https://cdns.klimg').replace('http://klimg', 'https://cdns.klimg');
        },
        img_on_error: function(e)
        {
            let domain= this.domain
            if (domain) {
                if(domain.includes('otosia')){
                    e.target.src  = 'assets/pwa/assets/image-default-otosia.png';
                }
                else if(domain.includes('enamplus')){
                    e.target.src  = 'assets/pwa/assets/image-default-enam-plus.png';
                }
                else{
                    if (this.subDomain) {
                        e.target.src = 'assets/pwa/assets/image-default-'+this.subDomain+'.png';
                    } else {
                        e.target.src = 'assets/pwa/assets/image-default.png';
                    }
                }
            } else {
                e.target.src  = 'assets/pwa/assets/image-default.png';
            }
        },
        back_to_top: function()
        {
            window.scrollTo({top: 0,behavior: 'smooth'});
        },
        ismobile: function() {
            var check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            return check;
        },
        getCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0;i < ca.length;i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
        },
        setCookie(name, value, days, domain) {
            var expires, domains = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days*24*60*60*1000));
                expires = "; expires=" + date.toUTCString();
            }
            if (domain) {
                domains = ";domain=." + domain;
            }
            var secure = '';
            if (location.protocol === 'https:') {
                secure = 'SameSite=None; Secure; ';
            }
            document.cookie = name + "=" + (value || "")  + expires + domains + "; "+ secure +"path=/";
        }
    }
}